var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ArticleHeader',{attrs:{"img_header":_vm.header_image,"header":"บทความ","link_back":"managewebsite"}}),_c('Article_manage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }